import React from 'react';
import { DropdownMenu } from 'reactstrap';
import merge from 'classnames';

import { Props } from './types';

import './DropdownMenu.module.scss';

export const ProxyDropdownMenu = (props: Props) => {
  const { className, itemsSize = 'small', flip = false, ...restProps } = props;

  return (
    <DropdownMenu
      {...restProps}
      className={merge(className, `${itemsSize}-items`)}
      data-testid="dropdown-menu"
      flip={flip}
    />
  );
};
